import React from 'react';
import { string, object, func, bool, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import { withMediaQuery } from 'common/utils';
import { getButtonsArray } from 'components/Banner/HeroBanner/utils';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';
import Button from 'elements/Buttons/Button';

import styles from './TypeB.css';

const cx = classnames.bind(styles);

const TypeB = ({ className, description, link, button, onClick, v2, colorScheme }) => {
  const buttons = button &&
    getButtonsArray(
      button,
      onClick,
      classnames(
        styles.button,
        {
          'white': colorScheme === 'pb01',
          'secondary': colorScheme === 'pb01'
        }
      )
    );
  
  return (
    <div className={cx('container', colorScheme, className, { 'v2': v2 })}>
      <div className={styles.wrapper}>
        <p className={styles.description}>{description}</p>
        {
          link &&
            <LinkFreeStanding
              className={styles.link}
              icon={{ direction: 'right', name: 'arrow-right', type: '20' }}
              size="m"
              dark
              withBouncing
              onClick={onClick}
            >
              {link}
            </LinkFreeStanding>
        }
        {button && withMediaQuery(Button, buttons)}
      </div>
    </div>
  );
};

TypeB.propTypes = {
  colorScheme: oneOf(['pb01', 'lb01']),
  className: string,
  description: string.isRequired,
  link: string,
  button: object,
  onClick: func.isRequired,
  v2: bool
};

TypeB.defaultProps = {
  colorScheme: 'pb01'
};

TypeB.displayName = 'TypeB';

export default TypeB;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/TypeB/TypeB.js